import React from 'react'
import { useDispatch } from 'react-redux'
import saveImg from '../../assets/social/save.svg'
import { PriceTagClear } from '../../redux/actions/PriceTagActions'
import {
  DeleteSavedItems,
  DeleteSavedProducts,
  SaveItem,
  SaveProduct
} from '../../redux/actions/SaveProductAction'
import { logEvent } from '../../utils/firebase'
import * as styles from './details.module.css'

export const SaveProductIcon = ({
  id,
  savedProductIds,
  saveObjectId,
  type
}) => {
  const dispatch = useDispatch()

  //check if product is saved or not yet
  const savedProduct =
    savedProductIds &&
    savedProductIds.length > 0 &&
    savedProductIds.includes(id)

  const clicked = e => {
    e.preventDefault()
    e.stopPropagation()
    e.nativeEvent.stopImmediatePropagation()

    if (savedProduct) {
      logEvent('unsave', {
        content_type: 'product',
        content_id: saveObjectId
      })

      const tag = 'design_productunsave_clicked'
      logEvent(tag)

      if (type === 'Item') {
        dispatch(DeleteSavedItems([saveObjectId], [id]))
        return
      }
      //product currently saved. Need to delete
      dispatch(DeleteSavedProducts([saveObjectId], [id]))
    } else {
      logEvent('save', {
        content_type: 'product',
        content_id: saveObjectId
      })

      const tag = 'design_productsave_clicked'
      logEvent(tag)

      if (type === 'Item') {
        dispatch(SaveItem([id]))
        return
      }
      //product not saved
      dispatch(SaveProduct([id]))
    }
  }

  return (
    <div
      className={`${styles.saveIconContainer} ${
        savedProduct ? styles.active : ''
      } `}
      onClick={clicked}
    >
      <img src={saveImg} alt="" className={styles.saveIcon} />
    </div>
  )
}
